import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import Title from './components/title/Title';
import Timeline from './components/timeline/Timeline';
import { Button } from 'primereact/button';
import styles from './StatusProposta.module.scss';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Pages from '../../../config/Pages';
import propostaStatusService from '../../../service/PropostaStatusService';
import { arrayToDateString } from '../../../core/utils/DateMixins';
import HeaderProposta from '../components/headerProposta/HeaderProposta';

function StatusProposta() {
    const { state } = useLocation();
    const history = useHistory();
    const { id } = useParams();
    const [registros, setRegistros] = useState();
    const [proposta, setProposta] = useState();

    useEffect(() => {
        const init = async () => {
            const response = await propostaStatusService.list({
                params: { search: `proposta.id==${id}`, sort: 'dataCadastro,asc' },
            });

            if (response.length > 0) {
                setProposta(response[0]?.proposta);
            }
            setRegistros(
                response.map(
                    ({
                        id,
                        arquivo,
                        faseProposta,
                        contaAcessoCadastro,
                        dataCadastro,
                        flagRecusa = false,
                        situacaoProposta,
                    }) => ({
                        id,
                        status: faseProposta?.descFaseProposta,
                        situacao: situacaoProposta?.descSituacao,
                        dataCadastro: arrayToDateString(dataCadastro, true),
                        usuarioCadastro: contaAcessoCadastro?.nome,
                        registroReprovacao: flagRecusa,
                        file: arquivo,
                    })
                )
            );
        };
        init();
    }, []);

    return (
        <Card>
            <Title />
            <HeaderProposta
                className={styles.header}
                numeroProposta={proposta?.id}
                nomeIndicador={proposta?.nmIndicador}
                numrVersao={proposta?.numrVersao}
                descTipoProposta={proposta?.tipoProposta?.descTipoProposta}
            />
            <div className={styles.container}>
                <Timeline events={registros} />
            </div>
            <div className={`buttonsRight ${styles.buttonVoltar}`}>
                <Button
                    label="Voltar"
                    icon="pi pi-arrow-left"
                    className="p-button-secondary"
                    onClick={() =>
                        history.push(state?.from ?? Pages.sei.propostaIndicador.url.list)
                    }
                />
            </div>
        </Card>
    );
}

export default StatusProposta;
